// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__INd0x","content":"GlobalSearch_content__2GO6R"};